(function() { window.GUID_1a2bb248_0eae_4b1c_87a2_6a4e9abc172c = { getGuid: function() { return "1a2bb248-0eae-4b1c-87a2-6a4e9abc172c"; } }; })();
var CompuSport;
(function (CompuSport) {
    var timeOutId = null;
    function Lag(lagTime, callback) {
        if (timeOutId != null) {
            clearTimeout(timeOutId);
        }
        timeOutId = setTimeout(callback, lagTime);
        return timeOutId;
    }
    CompuSport.Lag = Lag;
    function LagLocal(localTimeOutId, lagTime, callback) {
        if (localTimeOutId != null) {
            clearTimeout(localTimeOutId);
        }
        localTimeOutId = window.setTimeout(callback, lagTime);
        return localTimeOutId;
    }
    CompuSport.LagLocal = LagLocal;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Lag.js.map
